(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["c5-ship-bar"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__cfshInit) return;
  window.__cfshInit = true;
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function paint(cart) {
    var roots = document.querySelectorAll('[data-cfsh]');
    for (var i = 0; i < roots.length; i++) {
      var r = roots[i];
      var free = parseInt(r.getAttribute('data-free'), 10) || 9900;
      var t = cart.items_subtotal_price;
      var line = r.querySelector('[data-cfsh-line]');
      var fill = r.querySelector('[data-cfsh-fill]');
      var pct = Math.min(100, Math.round(100 * t / free));
      if (line) line.innerHTML = t >= free ? "You've unlocked free US shipping" : 'Add <b>' + money(free - t) + '</b> more for free US shipping';
      if (fill) { fill.style.width = pct + '%'; if (fill.parentNode) fill.parentNode.setAttribute('aria-valuenow', pct); }
      r.classList.toggle('cfsh--done', t >= free);
    }
  }
  function refreshAddons() {
    fetch('/?sections=c5-cart-bar&_=' + Date.now(), { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var tmp = document.createElement('div');
        tmp.innerHTML = j['c5-cart-bar'] || '';
        var fresh = tmp.querySelector('.cfsh-add');
        var roots = document.querySelectorAll('[data-cfsh]');
        for (var i = 0; i < roots.length; i++) {
          var old = roots[i].querySelector('.cfsh-add');
          if (old) old.remove();
          if (fresh) roots[i].appendChild(fresh.cloneNode(true));
        }
      }).catch(function () {});
  }
  function sync() {
    fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) { paint(c); refreshAddons(); }).catch(function () {});
  }
  function notifyTheme(cart) {
    try {
      import('@shopify/events').then(function (m) {
        var def = m.CartLinesUpdateEvent.createPromise();
        document.dispatchEvent(new m.CartLinesUpdateEvent({ action: 'add', context: 'c5-cart-bar', lines: [], promise: def.promise }));
        def.resolve({ cart: m.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'c5-cart-bar' } });
      }).catch(function () {});
    } catch (e) {}
  }
  var of = window.fetch;
  window.fetch = function (input) {
    var p = of.apply(this, arguments);
    try {
      var u = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(u)) p.then(function () { setTimeout(sync, 200); }, function () {});
    } catch (e) {}
    return p;
  };
  document.addEventListener('cart:refresh', function () { setTimeout(sync, 200); });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cfsh-add]');
    if (!b || b.disabled) return;
    e.preventDefault();
    var old = b.textContent;
    b.disabled = true;
    b.textContent = 'Adding...';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: Number(b.getAttribute('data-cfsh-add')), quantity: 1 }) })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.id) {
          b.textContent = 'Added';
          b.classList.add('is-added');
          return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) { paint(c); notifyTheme(c); });
        }
        b.disabled = false;
        b.textContent = old;
      })
      .catch(function () { b.disabled = false; b.textContent = old; });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
